import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, change } from 'redux-form';
import Button from '../../elements/Button';
import Text from '../../fields/Text';
import styles from './styles.scoped.css';
import IconWarning from '../../icons/IconWarning';
import { messageMapping } from './validate';
import IconSearch from '../../icons/IconSearch';
import Select from '../../fields/SelectBox';

export default function FilterMerchantForm({
  // handleSubmit,
  handledReset,
  message,
  code,
  handleSubmitMerchant = () => {},
  // handledClose = () => { }
}) {
  const dispatch = useDispatch();
  const values = useSelector((state) => state?.form?.filterMerchantForm?.values || {});
  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmitMerchant(values);
  };

  useEffect(() => {
    if (values?.field) {
      handledReset();
      dispatch(change('filterMerchantForm', 'search', ''));
    }
  }, [values?.field]);

  useEffect(() => {
    if (values?.search) {
      handledReset();
    }
  }, [values?.search]);

  return (
    <form className={styles.formContainer} onSubmit={onSubmit}>
      <Field
        component={Select}
        data={[
          { value: 'registrationId', label: 'ID Pangkalan' },
          { value: 'midMap', label: 'MID' },
          { value: 'phoneNumber', label: 'No Handphone' },
          { value: 'email', label: 'Email' },
        ]}
        inputProps={{
          placeholder: 'Pilih Parameter',
          data: [
            { value: 'registrationId', label: 'ID Pangkalan' },
            { value: 'midMap', label: 'MID' },
            { value: 'phoneNumber', label: 'No Handphone' },
            { value: 'email', label: 'Email' },
          ]
        }}
        name={'field'}
        onChange={(e) => dispatch(change('filterMerchantForm', 'field', e))}
      />
      <Field
        component={Text}
        disabled={!values?.field}
        inputProps={{
          placeholder: 'Masukkan data..'
        }}
        meta={{
          error: (message && code !== 401) && <>
            <IconWarning className={styles.icon} color="#CF212A" /> {message === 'Data tidak ditemukan' ? messageMapping[values?.field] : message}
          </>,
          touched: true,
        }}
        name={'search'}
        onChange={(e) => dispatch(change('filterMerchantForm', 'search', e.target.value))}
      />
      <div className={styles.containerBtn}>
        <Button
          className={styles.btn}
          disabled={!values?.search}
          type="submit"
        ><IconSearch /> Cari Pangkalan</Button>
      </div>
    </form>
  );
}

FilterMerchantForm.propTypes = {
  code: PropTypes.number,
  handledClose: PropTypes.func,
  handledReset: PropTypes.func,
  handleSubmitMerchant: PropTypes.func,
  message: PropTypes.string,
};
